import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Logo from './Logo';

function AppHeader({ title, showBack = false, showLogo = false, fallbackRoute = '/loads', rightAction = null }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallbackRoute);
    }
  };

  return (
    <header style={styles.header}>
      {/* Left slot — back button OR logo, never both */}
      <div style={styles.sideSlot}>
        {showBack && (
          <button onClick={handleBack} style={styles.backBtn}>
            <ChevronLeft size={24} color="#1f2937" />
          </button>
        )}
        {showLogo && !showBack && <Logo size={30} variant="white-bg" />}
      </div>

      {/* Center slot — always perfectly centered, regardless of left/right content width */}
      <h1 style={styles.title}>{title}</h1>

      {/* Right slot — filter icon, notification bell, or nothing */}
      <div style={{ ...styles.sideSlot, justifyContent: 'flex-end' }}>
        {rightAction}
      </div>
    </header>
  );
}

const styles = {
 header: {
  position: 'sticky',
  top: 0,
  background: 'white',
  minHeight: 56,
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  alignItems: 'center',
  paddingLeft: 12,
  paddingRight: 12,
  paddingTop: 'calc(env(safe-area-inset-top) + 8px)',
  paddingBottom: 8,
  boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
  zIndex: 40,
},
  sideSlot: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 30, // keeps spacing consistent even when empty
  },
  backBtn: {
    background: 'none',
    border: 'none',
    padding: 8,
    marginLeft: -8,
    cursor: 'pointer',
    borderRadius: 999,
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontSize: 17,
    fontWeight: 700,
    color: '#111827',
    margin: 0,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
};

export default AppHeader;